import PropTypes from 'prop-types'
import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import Link from 'components/Link'
import { isArray as _isArray } from 'lodash'
import Icon from 'components/Icon'
import TileArticlePlaceholder from 'components/TileArticlePlaceholder'
import { TYPE_PLACEHOLDER } from 'services/content-type'

export const TILE_ARTICLE_TYPE_STANDARD = 'standard'
export const TILE_ARTICLE_TYPE_META_OVERLAY = 'metaOverlay'
export const TILE_ARTICLE_TYPE_STANDARD_GRID = 'standardGrid'
export const TILE_ARTICLE_SIZE_DEFAULT = 'default'
export const TILE_ARTICLE_SIZE_XLARGE = 'xLarge'
export const TILE_ARTICLE_SIZE_LARGE = 'large'
export const TILE_ARTICLE_SIZE_MEDIUM = 'medium'
export const TILE_ARTICLE_SIZE_SMALL = 'small'

function getClassName (name, classes, type, size) {
  const tileArticleClasses = [name].concat(_isArray(classes) ? classes : [])
  if (type === TILE_ARTICLE_TYPE_META_OVERLAY) {
    tileArticleClasses.push(`${name}--meta-overlay`)
  } else if (type === TILE_ARTICLE_TYPE_STANDARD_GRID) {
    tileArticleClasses.push(`${name}--standard-grid`)
  } else {
    tileArticleClasses.push(`${name}--standard`)
  }

  switch (size) {
    case TILE_ARTICLE_SIZE_XLARGE:
      tileArticleClasses.push(`${name}--x-large`)
      break
    case TILE_ARTICLE_SIZE_LARGE:
      tileArticleClasses.push(`${name}--large`)
      break
    case TILE_ARTICLE_SIZE_MEDIUM:
      tileArticleClasses.push(`${name}--medium`)
      break
    case TILE_ARTICLE_SIZE_SMALL:
      tileArticleClasses.push(`${name}--small`)
      break
    default:
      tileArticleClasses.push(`${name}--default`)
  }
  return tileArticleClasses.join(' ')
}

function getKeyImageStyle (image) {
  return {
    backgroundImage: `url(${image})`,
  }
}

function TileArticle (props) {
  if (props.type === TYPE_PLACEHOLDER) {
    return <TileArticlePlaceholder />
  }
  return (
    <div
      className={getClassName(
        'tile-article',
        props.className,
        props.articleTileType,
        props.size,
      )}
    >
      <Link
        to={props.path}
        className={getClassName(
          'tile-article__key-image',
          [],
          props.articleTileType,
          props.size,
        )}
        style={getKeyImageStyle(props.image)}
      >
        {props.articleTileType === TILE_ARTICLE_TYPE_META_OVERLAY ? (
          <div className="tile-article__overlay" />
        ) : null}
        <Icon
          iconClass={['icon--article', 'icon--white', 'tile-article__icon']}
        />
      </Link>
      <div className="tile-article__meta">
        <div className="tile-article__author">{props.author}</div>
        <Link to={props.path} className="tile-article__title">
          {props.title}
        </Link>
        <div className="tile-article__date">{props.dateTimeText}</div>
        <div
          className={getClassName(
            'tile-article__description',
            [],
            props.articleTileType,
            props.size,
          )}
        >
          {props.description}
        </div>
      </div>
    </div>
  )
}

TileArticle.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  id: PropTypes.number,
  type: PropTypes.string.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  path: PropTypes.string,
  image: PropTypes.string,
  dateTimeText: PropTypes.string,
  author: PropTypes.string,
  authorPath: PropTypes.string,
  articleTileType: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  className: PropTypes.array,
}

export default TileArticle
